"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ModalHeaderContainer = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("@rebass/grid");
var _Title = _interopRequireDefault(require("../primitive/Title"));
var _excluded = ["children", "variant"];
var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
    variant = _ref.variant,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ModalHeaderContainer, props, /*#__PURE__*/_react["default"].createElement(_grid.Flex, null, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    variant: variant,
    elementType: "h1"
  }, children)));
};
var _default = exports["default"] = ModalHeader;
var ModalHeaderContainer = exports.ModalHeaderContainer = _styledComponents["default"].div.withConfig({
  displayName: "ModalHeader__ModalHeaderContainer",
  componentId: "sc-1k3hp4u-0"
})(["display:flex;justify-content:center;border-bottom:1px solid ", ";min-height:4.8rem;width:100%;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.neutral['30'];
});
//# sourceMappingURL=ModalHeader.js.map